import { AnalyticIdentifier } from '@common/neo.tax';
import { colors, Stack, Typography } from '@ui-components/neo.tax';

import { ProviderType } from '@neo.tax/shared/graphql';
import { useAnalyticId } from '@neo.tax/shared/state';

import { InstructionList, InstructionListItem, InstructionsIntroText } from './upload-instructions.styled';

interface UploadInstructionsProps {
  providerType: ProviderType;
  onDownloadTemplate: () => Promise<void>;
  isDownloading: boolean;
}

export const UploadInstructions = ({
  isDownloading,
  onDownloadTemplate,
  providerType,
}: UploadInstructionsProps): React.ReactElement => {
  const downloadLinkId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_DOWNLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT_LINK);

  const onDownloadTemplateClicked = async (): Promise<void> => {
    if (!isDownloading) {
      await onDownloadTemplate();
    }
  };

  return (
    <Stack direction="column" gap={2}>
      <InstructionsIntroText as="p" fontSize="sm" fontWeight="normal">
        Edit the project allocations for {providerType === ProviderType.Payroll ? 'wage' : 'non-wage'} expenses in bulk.
      </InstructionsIntroText>
      <InstructionList $listStyle="decimal">
        <InstructionListItem>
          Download the current expense allocations{' '}
          <Typography
            as="button"
            fontSize="sm"
            color={colors.primary[600]}
            fontWeight="medium"
            onClick={onDownloadTemplateClicked}
            id={downloadLinkId}
          >
            here
          </Typography>
          .
        </InstructionListItem>
        <InstructionListItem>Set or edit allocations in the spreadsheet.</InstructionListItem>
        <InstructionListItem>Drag and drop the updated spreadsheet below.</InstructionListItem>
      </InstructionList>
    </Stack>
  );
};
